import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import backarrow from "../../../../components/Images/backarrow.svg";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";

function Recaptcha_Setting(props) {
  const [message, setMessage] = useState("");

  const [capcha, setCapcha] = useState({
    captcha_site_key: "",
    captcha_secret_key: "",
    captcha: "",
    enable_captcha_login: "",
    enable_captcha_signup: "",
    enable_captcha_contactus: "",
  });
  const combinedRef = useRef({});

  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/setting/captchas`, {
        headers: headers,
      })
      .then((response) => {
        var captchas = response?.data?.captcha_setting[0];
        setCapcha(captchas);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;

    // Don't allow input if it's only whitespace
    if (value.trim() === '') {
      setCapcha((prev) => ({ ...prev, [name]: '' }));
      return;
    }

    setCapcha((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear related validation messages only when something valid is entered
    if (name === 'captcha_site_key') {
      setValidationMessagecaptcha_site_key("");
      setIsValidationHiddencaptcha_site_key(true);
    } else if (name === 'captcha_secret_key') {
      setValidationMessagecaptcha_secret_key("");
      setIsValidationHiddencaptcha_secret_key(true);
    }
  };


  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setCapcha({ ...capcha, [e.target.name]: 1 });
    } else {
      setCapcha({ ...capcha, [e.target.name]: 0 });
    }
  };


  const [validationMessagecaptcha_site_key, setValidationMessagecaptcha_site_key] =
    useState("");
  const [isValidationHiddencaptcha_site_key, setIsValidationHiddencaptcha_site_key] =
    useState(true);

  const [validationMessagecaptcha_secret_key, setValidationMessagecaptcha_secret_key] =
    useState("");
  const [isValidationHiddencaptcha_secret_key, setIsValidationHiddencaptcha_secret_key] =
    useState(true);

  const captcha_site_keyInputRef = useRef(null);
  const captcha_secret_keyInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const formValidation = async () => {
    let isValid = true;

    if (!capcha?.captcha_site_key?.trim()) {
      setValidationMessagecaptcha_site_key("Please enter captcha site key");
      setIsValidationHiddencaptcha_site_key(false);
      combinedRef.current['captcha_site_keyInputRef'].focus();
      isValid = false;
    } else {
      setValidationMessagecaptcha_site_key("");
      setIsValidationHiddencaptcha_site_key(true);
    }

    if (!capcha?.captcha_secret_key?.trim()) {
      setValidationMessagecaptcha_secret_key("Please enter captcha secret key");
      setIsValidationHiddencaptcha_secret_key(false);
      if (isValid) combinedRef.current['captcha_secret_keyInputRef'].focus(); // only override focus if previous was valid
      isValid = false;
    } else {
      setValidationMessagecaptcha_secret_key("");
      setIsValidationHiddencaptcha_secret_key(true);
    }

    return isValid;
  };


  const handleUpdate = async (e) => {
    if (!await formValidation()) {
      return;
    }
    e.preventDefault();

    const editInputvalue = {
      captcha_site_key: capcha?.captcha_site_key,
      captcha_secret_key: capcha?.captcha_secret_key,
      enable_captcha_login: capcha?.enable_captcha_login,
      enable_captcha_signup: capcha?.enable_captcha_signup,
      enable_captcha_contactus: capcha?.enable_captcha_contactus,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/setting/captchas-store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res?.json();

      if (resjson?.status === true) {
        firstApiStatus = true;

        resultapi = resjson;

        // secondApiStatus = true;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setValidationMessagecaptcha_site_key("");
      setValidationMessagecaptcha_secret_key("");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setIsValidationHiddencaptcha_secret_key(false);
        setIsValidationHiddencaptcha_site_key(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const editInputcapcha = {
  //     captcha_site_key: capcha.captcha_site_key,
  //     captcha_secret_key: capcha.captcha_secret_key,
  //     enable_captcha: capcha.enable_captcha,
  //   };
  //   // console.log(editInputvalue);
  //   let capchas = await fetch(
  //     `${process.env.REACT_APP_Baseurl}/admin/captcha/store`,
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + access_token,
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //       cache: "no-cache",
  //       credentials: "same-origin",
  //       redirect: "follow",
  //       referrer: "no-referrer",
  //       body: JSON.stringify(editInputcapcha),
  //     }
  //   );

  //   // console.log(resjson)
  //   if (capchas.status === 200) {
  //     setMessage(capchas.success);
  //     alert("Success");
  //     // window.location.reload();
  //     setTimeout(() => {}, 2000);
  //   } else {
  //     setMessage("Some error Occured");
  //     console.log("Error");
  //     alert("Enter Correct Details");
  //   }
  // };

  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h4 className="admin-title mb-0 theme-text-color">Recaptcha Settings</h4>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3">
                    Save Re-captcha
                  </button>
                </div>
              </div>
            </div>

            <div>
              {showOverlay && <Response_Processing></Response_Processing>}
            </div>

            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Create Site</h5>
                  <div className=" text-start">
                    <MessageLabel text={"Captcha Site Key"} className="mandatorySimple" />
                    <AdminCustomInput
                      id="captcha-site-key"
                      name="captcha_site_key"
                      type="text"
                      ref={(el) => (combinedRef.current.captcha_site_keyInputRef = el)}
                      value={capcha?.captcha_site_key}
                      onChange={handleInput}
                      placeHolder={"Site key"}
                      error={validationMessagecaptcha_site_key}
                    />
                  </div>
                  <div className="mt-2 text-start">
                    <MessageLabel text={"Captcha Secret Key"} className="mandatorySimple" />
                    <AdminCustomInput
                      id="captcha-secret-key"
                      name="captcha_secret_key"
                      type="text"
                      ref={(el) => (combinedRef.current.captcha_secret_keyInputRef = el)}
                      value={capcha?.captcha_secret_key}
                      onChange={handleInput}
                      placeHolder={"Secret key"}
                      error={validationMessagecaptcha_secret_key}
                    />
                  </div>
                </div>

                {/* <div className="text-start mb-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    Save PPV
                  </button>
                </div> */}
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0">Status Settings</h5>
                  <div className="row">
                    <div className="col-9 col-sm-9 col-lg-9">
                      <p className="p2">Enable Sign-in Captcha</p>
                    </div>
                    <div className="col-3 col-sm-3 col-lg-3 text-end">
                      {/* <label className="switch">
                        <input
                          name="enable_captcha_login"
                          id="enable_captcha_login"
                          onChange={handleInputenable}
                          className="rs-input"
                          defaultChecked={
                            capcha?.enable_captcha_login == 1 ? true : false
                          }
                          checked={capcha?.enable_captcha_login == 1 ? true : false}
                          type="checkbox"
                        />
                        <span
                          className="slider round"
                          name="enable_captcha_login"
                          id="enable_captcha_login"
                          onChange={handleInputenable}
                          value={capcha?.enable_captcha_login == 1 ? "1" : "0"}
                        ></span>
                      </label> */}
                      <AdminSwitch name="enable_captcha_login" checked={capcha?.enable_captcha_login == 1} onChange={(e) => handleInputenable(e, capcha)} id={capcha?.enable_captcha_login} />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-9 col-sm-9 col-lg-9">
                      <p className="p2">Enable Sign-up Captcha</p>
                    </div>
                    <div className="col-3 col-sm-3 col-lg-3 text-end">
                      {/* <label className="switch">
                        <input
                          name="enable_captcha_signup"
                          id="enable_captcha_signup"
                          onChange={handleInputenable}
                          className="rs-input"
                          defaultChecked={
                            capcha?.enable_captcha_signup == 1 ? true : false
                          }
                          checked={capcha?.enable_captcha_signup == 1 ? true : false}
                          type="checkbox"
                        />
                        <span
                          className="slider round"
                          name="enable_captcha_signup"
                          id="enable_captcha_signup"
                          onChange={handleInputenable}
                          value={capcha?.enable_captcha_signup == 1 ? "1" : "0"}
                        ></span>
                      </label> */}
                      <AdminSwitch name="enable_captcha_signup" checked={capcha?.enable_captcha_signup == 1} onChange={(e) => handleInputenable(e, capcha)} id={capcha?.enable_captcha_signup} />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-9 col-sm-9 col-lg-9">
                      <p className="p2">Enable Contact-us Captcha</p>
                    </div>
                    <div className="col-3 col-sm-3 col-lg-3 text-end">
                      {/* <label className="switch">
                        <input
                          name="enable_captcha_contactus"
                          id="enable_captcha_contactus"
                          onChange={handleInputenable}
                          className="rs-input"
                          defaultChecked={
                            capcha?.enable_captcha_contactus == 1 ? true : false
                          }
                          checked={capcha?.enable_captcha_contactus == 1 ? true : false}
                          type="checkbox"
                        />
                        <span
                          className="slider round"
                          name="enable_captcha_contactus"
                          id="enable_captcha_contactus"
                          onChange={handleInputenable}
                          value={capcha?.enable_captcha_contactus == 1 ? "1" : "0"}
                        ></span>
                      </label> */}
                      <AdminSwitch name="enable_captcha_contactus" checked={capcha?.enable_captcha_contactus == 1} onChange={(e) => handleInputenable(e, capcha)} id={capcha?.enable_captcha_contactus} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Recaptcha_Setting;
